import { render } from "./KeywordPopularView.vue?vue&type=template&id=e9a20118&ts=true"
import script from "./KeywordPopularView.vue?vue&type=script&lang=ts"
export * from "./KeywordPopularView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__